import React from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './CricketScorecardV2.scss';

class Batting extends React.Component {
  static propTypes = {
    batsmen: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    equation: PropTypes.shape({}).isRequired,
    extras: PropTypes.shape({}).isRequired,
    tosswonby: PropTypes.string.isRequired,
  };

  render() {
    const { batsmen, equation, extras, isWapView, tosswonby } = this.props;
    return (
      <div className={`${s.scorecardTable} ${s['batting-table']}`}>
        <ul>
          {(!tosswonby || tosswonby === '') && (
            <li className={`${s.tableHeading} ${s.tableItem}`}>
              <span className={s.batsman}>Squad</span>
            </li>
          )}
          {tosswonby &&
            tosswonby !== '' && (
              <li className={`${s.tableHeading} ${s.tableItem}`}>
                <span className={s.batsman}>Batter</span>
                {isWapView ? (
                  <span className={s.runs}>R (B)</span>
                ) : (
                  <span className={s.runs}>Runs (Balls)</span>
                )}
                <span className={s.four}>4s</span>
                <span className={s.six}>6s</span>
                <span className={s.strikeRate}>SR</span>
              </li>
            )}

          {Array.isArray(batsmen) &&
            batsmen.length > 0 &&
            batsmen.map((batsman, index) => {
              const batsmanClass = classNames({
                [`${s.striker}`]: batsman.striker === 'Yes',
                [`${s.batting}`]:
                  batsman.howOut === 'Batting' || batsman.howOut === 'not out',
                [`${s.out}`]: batsman.dismissal === 'out',
                [`${s.batsmanin}`]: batsman.issupersub,
                [`${s.batsmanout}`]: batsman.is_substituted,
              });

              return (
                <li
                  className={`${s.tableItem} ${batsmanClass}`}
                  key={`${batsman.name}-${index}`}
                >
                  <span className={s.batsman}>
                    <span className={s.name}>
                      <Link to={batsman.link} target="_blank">
                        {batsman.name}
                      </Link>
                    </span>
                    {!isWapView ? (
                      <span className={s.howOut}>{batsman.howOut}</span>
                    ) : (
                      ''
                    )}
                  </span>
                  <span className={s.runs}>
                    <strong>{batsman.runs}</strong>
                    {batsman.ballsFaced && ` (${batsman.ballsFaced})`}
                  </span>
                  <span className={s.four}>{batsman.fours}</span>
                  <span className={s.six}>{batsman.sixes}</span>
                  <span className={s.strikeRate}>
                    {batsman.strikeRate === '.00' ? '0.00' : batsman.strikeRate}
                  </span>
                  {isWapView ? (
                    <span className={s.howOut}>{batsman.howOut}</span>
                  ) : (
                    ''
                  )}
                </li>
              );
            })}
          {extras &&
            extras.total && (
              <li className={`${s.tableItem} ${s.extras}`}>
                <strong className={s.text}>Extras</strong>
                {/* <span /> */}
                <strong className={s.total}>{extras.total}</strong>
                <div className={s.extrasDetails}>
                  {extras.details &&
                    extras.details
                      .split(',')
                      .map(item => (
                        <small className={s.extraItem}>{item.trim()}</small>
                      ))}
                </div>
              </li>
            )}
          {equation &&
            equation.total && (
              <li
                className={`${s.tableItem} ${s.totalScore} ${s.blackHeading}`}
              >
                <span>Total</span>
                <span>
                  {equation.total}/{equation.wickets}{' '}
                  <small>
                    ({equation.overs} overs, rpo: {equation.runRate})
                  </small>
                </span>
              </li>
            )}
        </ul>
      </div>
    );
  }
}

export default Batting;
